import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const Loading = () => {
  return (
    <div className="midLoader">
      <div className="loadingBlock">
        <CircularProgress
          size={50}
          status="loading"
          top={50}
          left={50}
          style={{ top: "auto", left: "auto", transform: "none" }}
        />
      </div>
    </div>
  );
};

export default Loading;
